const YOUTUBE_ID_PATTERNS = [
  /youtu\.be\/([\w-]{6,})/i,
  /youtube\.com\/(?:embed|shorts|live|v)\/([\w-]{6,})/i,
  /youtube\.com\/watch\?(?:.*&)?v=([\w-]{6,})/i,
];

const VIMEO_ID_PATTERN = /vimeo\.com\/(?:video\/)?(\d+)/i;

/**
 * Converte o link informado no JSON de treinamentos em uma URL embedável.
 * Links que não são de YouTube/Vimeo são devolvidos como estão, assumindo que
 * já apontam para um player embedável.
 */
export function getVideoEmbedUrl(videoUrl?: string): string {
  const url = (videoUrl || '').trim();

  if (!url) {
    return '';
  }

  const youtubeId = YOUTUBE_ID_PATTERNS.reduce<string | null>(
    (found, pattern) => found || (url.match(pattern) || [])[1] || null,
    null
  );

  if (youtubeId) {
    return `https://www.youtube.com/embed/${youtubeId}?rel=0&modestbranding=1`;
  }

  const vimeoId = (url.match(VIMEO_ID_PATTERN) || [])[1];

  if (vimeoId) {
    return `https://player.vimeo.com/video/${vimeoId}`;
  }

  return url;
}
